import React from "react";

import { useElemInView } from "../../../../utils/customHooks/useElemInView";
import ListStyle from './comps/ListStyle'
import CardsStyle from './comps/CardsStyle'
import TableStyle from './comps/TableStyle'
import {UserProfilesStyle} from './comps/UserProfilesStyle'
import { PaddingTopBottom20 } from "oolib";
import EmptyStateListing from "./EmptyStateListing";
import { parseSpecialConfigSyntax } from "@okf/ootils";

import { useGetQueryData } from "@/utils/react-query-hooks/general";

const ListingModule = ({
  status,
  data,
  listingStyle,
  listingConfig: _listingConfig,
  fetchNextPage,
  isFetchingNextPage,
  totalCount,
  sectionTitle,
  sectionLink,
  activeSort,
  setActiveSort,
  hasNextPage,
  ListingWrapper,
  enableContainerQuery,
  emptyPageConfigSearch,
  contentTypes,
  inTCI,
  builderProps,
  getDataToBeExported,

}) => {
  
  const { observerRef } = useElemInView({
    callback: fetchNextPage,
    enabled: !!hasNextPage && !isFetchingNextPage,
  });
  const {SELF_MANAGED_BASE_CONFIGS} = useGetQueryData('platformConfigs')
  

const flattenPages = (data) => 
  data.pages.reduce((a,b) => [...a, ...b.data] ,[])
  

  const ListingStyles = {
    ListStyle,
    CardsStyle,
    TableStyle,    
    UserProfilesStyle,
  }


  const ThisListingStyle = ListingStyles[listingStyle];

  if(!ThisListingStyle) return null;

  
  const linkConfigForTableStyle = _listingConfig.linkConfig
  const linkConfigForOtherStyles = _listingConfig.linkConfig

  /**
   * what the below basically means: 
   * if the listingStyle is a table then:
   * --- if listingConfig.linkConfig || listingConfig.tableConfig.link already exists, then leave it be.
   * --- else set our default link if we are not in tci.
   * 
   * if listingStyle is anything else (cards or list)
   * --- if _listingConfig.linkConfig || listingConfig.linkTo already exists leave it be
   * --- else set our default link if we are not in tci.
   * 
   * // ideally listingConfig.linkConfig is better terming than linkTo or link.
   */
  const listingConfig = {
    ..._listingConfig,
    ...(
      listingStyle === 'TableStyle'
      ? {
        tableConfig: {
          ..._listingConfig.tableConfig,
          link: linkConfigForTableStyle
        }
      }
      : { linkTo: linkConfigForOtherStyles }

    )
    
  }

  

  return (
    <PaddingTopBottom20>

    {  data && flattenPages(data).length===0?
        <EmptyStateListing listingStyle={listingStyle} contentTypes={contentTypes} emptyPageConfigSearch={emptyPageConfigSearch} />
      :<ThisListingStyle
        status={status} 
        data={data && flattenPages(data)} 
        observerRef={hasNextPage?observerRef:null} 
        isFetchingNextPage={isFetchingNextPage}      
        totalCount={totalCount}
        sectionTitle={sectionTitle}
        sectionLink={sectionLink}
        activeSort={activeSort}
        setActiveSort={setActiveSort}
        hasNextPage={hasNextPage}
        ListingWrapper={ListingWrapper}
        {...listingConfig} 
        enableContainerQuery={enableContainerQuery}
        inTCI={inTCI}
        builderProps={builderProps}
        getDataToBeExported={getDataToBeExported}
     
        />}
    </PaddingTopBottom20>
  );
};

export default ListingModule;
